import React, { useCallback, useEffect, useState } from 'react'
import Drawer from "react-drag-drawer";
import { playSong } from '../../utils/song'
import songsName from '../../enums/songsName'
import { FiX } from 'react-icons/fi';
import Loading from '../loading';
import api from '../../services/api';
import ConfirmCancelPlanModal from './component/plans-section'
import LogoPng from '../../assets/images/new/logo.webp'
import { BsArrowLeftCircle } from 'react-icons/bs';

const PaymentModal = (props) => {
  const [loading, setIsLoading] = useState(false)
  const [plan, setPlan] = useState({})

  const [showConfirmCancelPlan, setShowConfirmCancelPlan] = useState(false)
  const [showCancelationSuccessMessage, setShowCancelationSuccessMessage] = useState(!props.hasUserASubscription)

  useEffect(() => {
    setShowCancelationSuccessMessage(!props.hasUserASubscription)
  }, [props.hasUserASubscription])

  const closeHandler = () => {
    playSong(songsName.TAP)
    props.close()
    setShowConfirmCancelPlan(false)
    // setShowCancelationSuccessMessage(false)
  }

  return (
    <Drawer
      dontApplyListeners={true}
      allowClose={false}
      open={props.isOpened}
      onRequestClose={() => {
        props.close()
        setShowConfirmCancelPlan(false)
        // setShowCancelationSuccessMessage(false)
      }}
      direction="left"
      modalElementClass="absolute top-0 left-0"
    >
      <div
        className={`w-screen max-w-lg h-screen bg-modal flex flex-col justify-start items-start px-4 pb-4 text-lg overflow-y-auto`}
        style={{
          paddingTop: window.native_app_status_bar_height ?? 16
        }}
      >
        <div className='w-full flex flex-row items-center justify-between mb-6'>
          <div className='w-full flex flex-row justify-between items-center'>
            <div
              className='flex flex-row justify-start items-center cursor-pointer'
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={() => {
                playSong(songsName.TAP)

                props.backToDrawerMenu()
              }}
            >
              <BsArrowLeftCircle className="w-8 h-8 text-pallet-1" />
            </div>

            <img src={LogoPng} className='h-8 mx-auto' alt='Logo' />

            <button
              type="button"
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={closeHandler}
              className={`text-black bg-transparent hover:bg-slate-200 rounded-lg text-2xl lg:text-xl`}
            >
              <FiX className="w-8 h-8 text-pallet-1" />
            </button>
          </div>
        </div>

        {!showCancelationSuccessMessage ? <h2 className='text-pallet-1 font-bold text-xl text-center mx-auto my-8'>Assinatura</h2> : null}

        {loading ? (
          <div className='flex flex-1 w-full flex-col justify-center items-center'>
            <Loading />
          </div>
        ) : (
          <div className='w-full overflow-y-scroll'>
            <ConfirmCancelPlanModal
              plan={plan}
              hasUserASubscription={props.hasUserASubscription}
              showConfirmCancelPlan={showConfirmCancelPlan}
              showCancelationSuccessMessage={showCancelationSuccessMessage}
              setShowConfirmCancelPlan={setShowConfirmCancelPlan}
              setShowCancelationSuccessMessage={setShowCancelationSuccessMessage}
              isUserInFreeTrial={props.isUserInFreeTrial}
              subscriberData={props.subscriberData}
              checkIfUserHasScubscription={props.checkIfUserHasScubscription}
              subscriptionData={props.subscriptionData}
            />

            {/* {!showConfirmCancelPlan && !showCancelationSuccessMessage ? (
              <CreditCardSection hasUserASubscription={props.hasUserASubscription} plan={plan} checkIfUserHasScubscription={props.checkIfUserHasScubscription} subscriberData={props.subscriberData} />
            ) : null} */}
          </div>
        )}
      </div>
    </Drawer>
  )
}

export default PaymentModal